import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

function ImagePopup({ open, handleClose, imgSrc }) {
  return (
    <Dialog open={open} onClose={handleClose} className='dialog-image'>
      <IconButton onClick={handleClose} style={{ position: 'absolute', right: 0, top: 0 }}>
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <img src={imgSrc} alt="Popup" style={{ width: '100%' }} />
      </DialogContent>
    </Dialog>
  );
}

export default ImagePopup;
